import { Campaign } from './types'

// closing soonest to latest
export const sortEstimateClosingSoonest = (a: Campaign, b: Campaign) => {
  // handle null cases
  if (b.hoursRemainingEstimate === null && a.hoursRemainingEstimate === null) {
    return 0
  } else if (a.hoursRemainingEstimate === null) {
    return 1
  } else if (b.hoursRemainingEstimate === null) {
    return -1
  }

  return a.hoursRemainingEstimate - b.hoursRemainingEstimate
}
